<template>

<div class="hide_on_mobile">

<div class="leftsidebar animate_class" :style="'width:'+menuleft">
<ScrollPanel style="width: 100%; height: 100%" class="left_sidebar_scroll">
<!--
<router-link class="menuitem animate_class  pt-3"  v-show="displaylogo" :to="'/'+$store.state.users.user.uuid+'/dashboard'"><div class=" logo_shrink raised_item menuitemcapital animate_class">V</div></router-link>
<h2	class="logo text-primary ml-2 pt-3 pb-4" v-show="displayname">VERIFY</h2>
<Divider class="mt-0 mb-4"/>

-->
<leftSidebarItem v-for="item in $store.state.ui.usermenu" :key="item.key" :data="item"></leftSidebarItem>
</ScrollPanel>

<!--
<div class="menu_disclaimer" v-if="showdisclaimer">
<leftSidebarItem  :data="disclaimer"></leftSidebarItem>
</div>
-->
</div>

</div>
</template>

<script>
import leftSidebarItem from  "./leftSidebarItem"
export default {

  name: 'leftSidebar',

  data () {
    return {
    	disclaimer:{
				key:"disclaimer",
				title:"yasal_uyari",
				link:"/disclaimer",
				capital:"D",
				color:"#ea2c54",
    	}
    }
  },
  components:{
  	leftSidebarItem
  },
  computed:{
  	uuid()
  	{
  		return this.$store.state.auth.user.uuid
  	},
  	showdisclaimer()
  	{
  		if(this.$store.state.auth.user.uuid)
  		{
  			this.disclaimer.link = "/"+this.$store.state.auth.user.uuid+"/disclaimer"
  			return true
  		}
  		return false
  	},
  	menuleft()
  	{
		if(this.$store.state.ui.menuopen)
		{
			return "240px"
		}
		else{
			return "66px"
		}
  	},
  	displaylogo()
  	{
		if(this.$store.state.ui.menuopen)
		{
			return false
		}
		else{
			return true
		}
  	},
  	displayname()
  	{
		if(this.$store.state.ui.menuopen)
		{
			return true
		}
		else{
			return false
		}
  	}
  },
};
</script>

<style lang="css" scoped>
</style>